import axios, { AxiosError } from "axios";
import { UseQueryResult, useQuery } from "react-query";
import { StrapiEwaBlockReasonResponse } from "../model/StrapiEwaBlockReason";

const StrapiCMSApiService = async (
  path: string,
  id?: number,
  populate?: string
): Promise<StrapiEwaBlockReasonResponse> => {
  const uri = `${process.env.REACT_APP_STRAPI_API_URL}/api/${path}${
    id ? `/${id}` : ""
  }?_limit=-1${populate ? `&populate${populate}` : ""}`;
  const { data } = await axios.get(uri, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
    },
  });
  return data;
};

const useGetBlockReasonsApiService = (): UseQueryResult<
  StrapiEwaBlockReasonResponse,
  AxiosError
> =>
  useQuery<
    Promise<StrapiEwaBlockReasonResponse>,
    AxiosError,
    StrapiEwaBlockReasonResponse
  >(["EwaBlockReason"], () => StrapiCMSApiService("ewa-block-reasons"));

export { useGetBlockReasonsApiService };
